var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-dialog", {
    staticClass: "wlc-image-preview",
    attrs: {
      top: "5vh",
      fullscreen: true,
      visible: _vm.visible,
      "destroy-on-close": ""
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c("el-carousel", {
    ref: "carousel",
    attrs: {
      "indicator-position": "none",
      autoplay: false,
      arrow: "always"
    }
  }, _vm._l(_vm.imgs, function (item, index) {
    return _c("el-carousel-item", {
      key: index
    }, [_c("img", {
      staticStyle: {
        width: "100%",
        height: "100%",
        "object-fit": "contain"
      },
      attrs: {
        src: item
      }
    })]);
  }), 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };